<template>
  <RemotePaginatedList
    :filter-options="filterOptions"
    :headers="headers"
    multi-datasett
    v-model="selectedItemIds"
    data-url="admin/dataset/datapoint/"
    data-key="points"
    :refresh-trigger.sync="innerRefreshTrigger"
    v-bind="$attrs"
    class="datapoint-list"
  >
    <template #item.period="{ value }">
      {{ $parsePeriod(value) }}
    </template>
    <template #item.import_from_api="{ value }">
      <v-icon v-if="!value">mdi-hand-back-left</v-icon>
    </template>
    <template #item.value="{ value, item }">
      {{
        item.dataset.value_type === RBU_DATASET_VALUE_TYPE.PRICE
          ? $parseCurrency(value)
          : $parseNumber(value)
      }}
    </template>
    <template #item.usage_count="{ value, item }">
      {{ item.usage_count }}
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="d-flex">
        <v-btn
          v-if="item.usage_count === 0 && canDelete && !item.import_from_api"
          text
          color="primary"
          @click="deleteItem(item)"
        >
          Delete
        </v-btn>
      </div>
    </template>
  </RemotePaginatedList>
</template>

<script>
import { onMounted, ref, watch, computed } from "@vue/composition-api";
import RemotePaginatedList from "../RemotePaginatedList";
import _ from "lodash";
import { ACTION_TYPES } from "@/store/types";
import { RBU_DATASET_VALUE_TYPE, USER_TYPE, PERMISSIONS } from "@/constants";

export default {
  name: "DatapointList",
  computed: {
    RBU_DATASET_VALUE_TYPE() {
      return RBU_DATASET_VALUE_TYPE;
    },
  },
  components: { RemotePaginatedList },
  props: {
    value: Array,
    refreshTrigger: Boolean,
  },
  setup(props, { root, emit }) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    const canDelete = computed(() => {
      if (!root.$store.getters.account) return false;
      return (
        [USER_TYPE.SUPER_ADMIN].includes(root.$store.getters.account.type) ||
        _.some([PERMISSIONS.MANAGE_RBU_DATASET], (p) =>
          root.$store.getters.hasPermission(p)
        )
      );
    });
    onMounted(() => {
      refresh(false);
    });

    watch(
      () => props.refreshTrigger,
      (newValue) => {
        if (newValue) {
          refresh(true);
          emit("update:refresh-trigger", false);
        }
      }
    );

    // Filter
    const filterOptions = ref([
      { text: root.$t("datapoint.type"), value: "type", contains: true },
      {
        text: root.$t("datapoint.descriptions"),
        value: "descriptions",
        contains: true,
      },
    ]);

    // Data Table
    const headers = ref([
      { text: root.$t("datapoint.type"), value: "type" },
      { text: "Manually Imported", value: "import_from_api" },
      { text: root.$t("datapoint.descriptions"), value: "descriptions" },
      { text: root.$t("datapoint.value"), value: "value" },
      { text: "Usage Count", value: "usage_count" },
      { text: "", value: "actions" },
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(
      () => selectedItemIds.value,
      (newValue) => {
        emit("input", newValue);
      }
    );
    watch(
      () => props.value,
      (newValue, oldValue) => {
        if (_.xor(newValue, oldValue).length) {
          selectedItemIds.value = newValue;
        }
      },
      { deep: true, immediate: true }
    );

    const editItem = async function (item) {
      root.$router.push({
        name: "rbu-dataset-issue",
        params: { datasetId: root.$route.params.datasetId, issueId: item.id },
      });
    };

    const deleteItem = async function (item) {
      if (await root.$dialog.confirm({ text: "Delete Datapoint?" })) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/dataset/datapoint/delete/",
          params: { datapoint_id: item.id },
        });

        await refresh();
      }
    };

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      editItem,
      deleteItem,
      canDelete,
    };
  },
};
</script>

<style lang="less">
.dataset-list {
}
</style>
